import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import type { Launch } from "../types/launch";

const launchesQueryKey = ["launch-media", "launches"] as const;

export function useLaunches() {
  return useQuery({
    queryKey: launchesQueryKey,
    queryFn: async () => {
      const response = await httpClient.mediaMgmt.get<{ launches: Launch[] }>(
        "/launches"
      );
      return response.launches;
    },
  });
}
